import { normalizeFieldData } from '../FieldData';

import { FormFieldEntity, FormFieldEntityApi } from './entity';

export const normalizeFormFieldEntity = (
  raw: FormFieldEntityApi
): FormFieldEntity => {
  return {
    pivotScreenVisibility: raw.pivot_screen_visibility,
    formId: raw.form_id,
    fieldData: normalizeFieldData(raw.field_data),
    id: raw.id,
    supervisorVisibility: raw.supervisor_visibility,
    fillingMethod: raw.filling_method,
    defaultVisibility: raw.default_visibility,
    importEditable: raw.import_editable,
    defaultValue: raw.default_value,
  };
};
